module.exports = __webpack_public_path__ + "static/media/purchase-worth.21bac666.svg";